import { render, staticRenderFns } from "./AddGenericName.vue?vue&type=template&id=7279c386"
import script from "./AddGenericName.vue?vue&type=script&lang=js"
export * from "./AddGenericName.vue?vue&type=script&lang=js"
import style0 from "./AddGenericName.vue?vue&type=style&index=0&id=7279c386&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports